import { FormlyFieldConfig } from "@ngx-formly/core";
import * as _ from "lodash";
import { EMAIL_FIELD, FIRST_NAME_FIELD, LAST_NAME_FIELD, MIDDLE_NAME_FIELD, US_PHONE_NUMBER_FIELD } from "./generic.fields";

export const BR_FIELDS = {
  non_citizenship_letter_scan: {
    props: {
      type: "pdf_document",
      message: "Please upload the non-citizenship letter.",
      friendly_name: "Non-Citizenship Letter Scan"
    }
  },
  contact: {
    address: {
      address_1: {
        type: "input",
        props: {
          label: "Street Address 1",
          maxLength: 20
        }
      },
      province: {
        type: "autocomplete",
        props: {
          label: "Province",
          options: [
            {
              label: "Acre",
              value: 1
            },
            {
              label: "Alagoas",
              value: 2
            },
            {
              label: "Amapá",
              value: 3
            },
            {
              label: "Amazonas",
              value: 4
            },
            {
              label: "Bahia",
              value: 5
            },
            {
              label: "Ceará",
              value: 6
            },
            {
              label: "Distrito Federal",
              value: 7
            },
            {
              label: "Espírito Santo",
              value: 8
            },
            {
              label: "Goiás",
              value: 9
            },
            {
              label: "Maranhão",
              value: 10
            },
            {
              label: "Mato Grosso",
              value: 11
            },
            {
              label: "Mato Grosso do Sul",
              value: 12
            },
            {
              label: "Minas Gerais",
              value: 13
            },
            {
              label: "Pará",
              value: 14
            },
            {
              label: "Paraíba",
              value: 15
            },
            {
              label: "Paraná",
              value: 16
            },
            {
              label: "Pernambuco",
              value: 17
            },
            {
              label: "Piauí",
              value: 18
            },
            {
              label: "Rio de Janeiro",
              value: 19
            },
            {
              label: "Rio Grande do Norte",
              value: 20
            },
            {
              label: "Rio Grande do Sul",
              value: 21
            },
            {
              label: "Rondônia",
              value: 22
            },
            {
              label: "Roraima",
              value: 23
            },
            {
              label: "Santa Catarina",
              value: 24
            },
            {
              label: "São Paulo",
              value: 25
            },
            {
              label: "Sergipe",
              value: 26
            },
            {
              label: "Tocantins",
              value: 27
            }
          ]
        }
      }
    },
    answer: {
      type: "yes-no-buttons"
    },
    name: {
      type: "input",
      props: {
        label: "Full Name",
        maxLength: 20
      }
    },
    relationship: {
      type: "select",
      props: {
        label: "Relationship",
        options: [
          {
            label: "Friend",
            value: "friend"
          },
          {
            label: "Relative",
            value: "relative"
          },
          {
            label: "Co-worker",
            value: "co-worker"
          },
          {
            label: "Neighbor",
            value: "neighbor"
          },
          {
            label: "Other",
            value: "other"
          }
        ]
      }
    },
    relationship_details: {
      type: "input",
      props: {
        label: "Description of Relationship",
        maxLength: 20
      },
    },
    phone: US_PHONE_NUMBER_FIELD,
    email: EMAIL_FIELD
  },
  previous_visits: {
    answer: {
      type: "yes-no-buttons"
    }
  },
  vitem_visa_activity: {
    type: "yes-no-buttons"
  },
  employment: {
    business_in_brazil: {
      answer: {
        type: "yes-no-buttons"
      },
      description: {
        type: "input",
        props: {
          label: "Nature of business conducted in Brazil",
          maxLength: 100
        }
      }
    },
    restricted_work: {
      answer: {
        type: "yes-no-buttons"
      }
    },
    position: {
      type: "input",
      props: {
        label: "Position",
        maxLength: 20
      },
      hooks: {
        onInit: (field: FormlyFieldConfig) => {
          if (field.formControl?.value) return

          let root: FormlyFieldConfig | undefined = field.parent
          while (root && root.parent) root = root.parent

          const fallback = _.get(root?.model || field.model, "employment_status.position")
          if (fallback) field.formControl?.setValue(fallback)
        }
      }
    }
  }
}

export const BR_APPLICATION_FIELDS = {
  entry_type: {
    type: "select",
    props: {
      label: "Entry Type",
      options: [
        {
          label: "Air",
          value: "air"
        },
        {
          label: "Land",
          value: "land"
        },
        {
          label: "Sea",
          value: "sea"
        }
      ]
    }
  },
  traveling_with: {
    type: "buttons",
    props: {
      options: [
        {
          label: "Travelling Alone",
          value: "alone"
        },
        {
          label: "Parents",
          value: "parents"
        },
        {
          label: "Guardians",
          value: "guardians"
        }
      ]
    }
  },
  guardian: {
    first_name: FIRST_NAME_FIELD,
    middle_name: MIDDLE_NAME_FIELD,
    last_name: LAST_NAME_FIELD,
    date_of_birth: {
      type: 'datepicker',
      props: {
        view: 'multi-year',
        after: [
          {
            date: '01/01/1900',
            message: 'Date of Birth must be after 01/01/1900'
          }
        ],
        label: 'Date of Birth',
        before: [
          {
            date: 'now',
            message: 'Date can’t be in the future'
          },
          {
            key: 'date_of_birth',
            parent: 'global',
            message: 'Date can’t be after applicant’s date of birth'
          }
        ]
      }
    }
  },
  autorization_letter_scan: {
    props: {
      type: "pdf_document",
      message: "Please upload the authorization letter from the applicant's parents to travel to Brazil.",
      friendly_name: "Authorization Letter Scan"
    }
  },
  previous_visits: {
    date_of_entry: {
      type: "datepicker",
      props: {
        view: "multi-year",
        label: "Date of Entry",
        before: [
          {
            date: "now",
            message: "Date can't be in the future."
          },
          {
            key: "application.previous_visits.date_of_exit",
            parent: "global",
            message: "Date of Entry must be before Date of Exit."
          }
        ]
      }
    },
    date_of_exit: {
      type: "datepicker",
      props: {
        view: "multi-year",
        after: [
          {
            key: "application.previous_visits.date_of_entry",
            parent: "global",
            message: "Date of Exit must be after Date of Entry."
          }
        ],
        label: "Date of Exit",
        before: [
          {
            date: "now",
            message: "Date can't be in the future."
          }
        ]
      }
    }
  },
  purpose: {
    type: "buttons",
    props: {
      label: "Purpose of Visit",
      options: [
        {
          label: "Tourism",
          value: "tourist"
        },
        {
          label: "Business",
          value: "business"
        }
      ],
    }
  }
}